import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import styled from "styled-components";

function ThicknessShape() {
  let [localThickness, setLocalThickness] = useState(0);
  const { currVariable } = useSelector((state) => state.toolsModification);
  console.log("currVariable in ThicknessShape", currVariable);
  const dispatch = useDispatch();
  // useEffect(() => {
  //     dispatch(currentBoxSize(boxSize));
  //   }, [boxSize]);
  const handleChange = (e) => {
    if(e.target.value<0) return
    let name = e.target.name;
    let value = Number(e.target.value);
    let data = { [name]: `${value}` };
    console.log("data for thicknesss", data)
    dispatch(updateCoordinate({ id: currVariable?.variable, newValue: data }));
    setLocalThickness(value)
  };

  useEffect(()=>{
    setLocalThickness(currVariable?.thickness)
  },[currVariable])

  return (
    <Wrapper style={{ position: "relative", left: "40px", width: "40px" }}>
      {/* <Wrapper style={{position:'relative', left:'98px',top:'8px',width:'40px'}} > */}
      <input
        type="number"
        value={ localThickness || currVariable?.thickness}
        onKeyDown={(e) => {
          if (["e", "E", "+", "-", "."].includes(e.key)) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
            const paste = e.clipboardData.getData('text');
            if (!/^\d+$/.test(paste)) {
              e.preventDefault();
            }
        }}
        onChange={handleChange}
        name="thickness"
        autoFocus
        style={inputStyle}
        min={1}
        step={1}
      />
    </Wrapper>
  );
}

export default ThicknessShape;
const inputStyle = {
  width: "100%",
  height: "33px",
  borderRadius: "5px",
  // border:'2px solid black'
};
const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    align-items: center;
    width: auto;
  }
  p {
    font-size: 12px;
  }
`;
